import { render } from "./HomeLimbo.vue?vue&type=template&id=009e7c2a&scoped=true"
const script = {}

import "./HomeLimbo.vue?vue&type=style&index=0&id=009e7c2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009e7c2a"]])

export default __exports__